/* eslint-disable jsx-a11y/control-has-associated-label */

/* eslint-disable react/jsx-props-no-spreading */
import { useRoutes } from '@folklore/routes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useLocation, useRoute } from 'wouter';

import useOpenedState from '../../../hooks/useOpenedState';
import * as AppPropTypes from '../../../lib/PropTypes';

import { useThemeClassName } from '../../../contexts/ThemeContext';
import HeaderDefault from '../../partials/HeaderDefault';
import OtherLocales from '../../partials/OtherLocales';

import styles from '../../../../styles/themes/rhoneacademy/header-rhoneacademy.module.scss';

import closeIcon from '../../../../img/rhoneacademy/icons/close.svg';
import menuIcon from '../../../../img/rhoneacademy/icons/menu.svg';
import logo from '../../../../img/rhoneacademy/logo.svg';

const propTypes = {
    className: PropTypes.string,
    pageUrls: AppPropTypes.pageUrls,
    footerMenuItems: AppPropTypes.menuItems,
};

const defaultProps = {
    className: null,
    pageUrls: null,
    footerMenuItems: null,
};

function HeaderRhoneacademy({ className, pageUrls, footerMenuItems, ...props }) {
    const openedState = useOpenedState();
    const { menuOpened } = openedState;
    const themeClassName = useThemeClassName(styles);
    const [pathname] = useLocation();
    const isHome = pathname === '/' || pathname.match(/^\/(fr|en)\/?$/) !== null;

    const { 'play.group': playGroupRoute } = useRoutes();
    const [isPlayGroupRoute] = useRoute(playGroupRoute);

    return (
        <HeaderDefault
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [styles.centered]: isHome,
                    [className]: className !== null,
                    [styles.menuOpened]: menuOpened,
                },
            ])}
            innerClassName={styles.inner}
            contentClassName={styles.content}
            fixedContentClassName={styles.fixedContent}
            togglerClassName={classNames(styles.toggler, { [styles.hidden]: isPlayGroupRoute })}
            togglerOpenedClassName={styles.togglerOpened}
            toggleContentClassName={styles.toggleContent}
            logoButtonClassName={styles.logoButton}
            logoClassName={styles.logo}
            menuClassName={styles.menu}
            itemsClassName={styles.menuItems}
            itemClassName={styles.menuItem}
            openedState={openedState}
            withoutOtherLocales
            menuLabel={
                menuOpened ? (
                    <div className={styles.togglerLabel}>
                        <img src={closeIcon} alt="Close" className={styles.icon} />
                    </div>
                ) : (
                    <div className={styles.togglerLabel}>
                        <img
                            src={menuIcon}
                            alt="Open"
                            className={classNames([styles.icon, styles.menuIcon])}
                        />
                    </div>
                )
            }
            menuChildren={
                <div className={styles.footer}>
                    <OtherLocales
                        className={styles.otherLocales}
                        linkClassName={styles.otherLocale}
                        pageUrls={pageUrls}
                        withFullLabel
                    />
                </div>
            }
            {...props}
        >
            {!isPlayGroupRoute ? (
                <div className={styles.logoContainer}>
                    <img src={logo} className={styles.logo} alt="Rhône Academy" />
                </div>
            ) : null}
        </HeaderDefault>
    );
}

HeaderRhoneacademy.propTypes = propTypes;
HeaderRhoneacademy.defaultProps = defaultProps;

export default HeaderRhoneacademy;
